// @flow
/*global RB */
import Geocode from 'react-geocode';
Geocode.setApiKey(_RB.GOOGLE_MAPS_API_KEY);

export type CareersPageFilterItemType = {
	option: { id: string | number, name: string },
	selected: boolean,
	count: number,
};

export type CareersPageFiltersType = {
	[filter_name: string]: {
		order: number,
		options: Array<CareersPageFilterItemType>,
	},
};

export const CAREER_PAGE_FILTERS = {
	countries: {
		label: 'Country',
		placeholder: 'country',
		query_name: 'country',
		key: 'COUNTRY',
	},
	states: {
		label: 'State',
		placeholder: 'state',
		query_name: 'state',
		key: 'STATE',
	},
	cities: {
		label: 'City',
		placeholder: 'city',
		query_name: 'city',
		key: 'CITY',
	},
	other_locations: {
		label: 'Other location',
		placeholder: 'location',
		query_name: 'other_location',
		key: 'OTHER_LOCATION',
	},
	teams: {
		label: 'Team',
		placeholder: 'team name',
		query_name: 'team_id',
		key: 'TEAM',
	},
};

export function getAllFiltersAvailable(): CareersPageFiltersType {
	return RB.init_data.filters;
}

type CareersPageSettingsType = {
	hosted_site_radius_search_enabled: boolean,
	hosted_site_filters: Array<string>, //Only the enabled filters will be present here.
};

export function getCareerPageSettings(): CareersPageSettingsType {
	return RB.init_data.settings;
}

export function isRadiusSearchEnabled(): boolean {
	return getCareerPageSettings().hosted_site_radius_search_enabled;
}

export function filtersAllow(): Array<string> {
	return getCareerPageSettings().hosted_site_filters;
}

export function searchWithFilter() {
	document.querySelector('.js-job-search-form').submit();
}

export function getSelectedFilters(): Array<{ key: 'string', name: string }> {
	const all_filters = getAllFiltersAvailable();

	const selected_filters = [];
	Object.entries(all_filters).map(([key, { options }]) => {
		options.map(filter_item => {
			if (filter_item.selected) {
				selected_filters.push({
					...filter_item,
					key: CAREER_PAGE_FILTERS[key].query_name,
				});
			}
		});
	});
	const address_selected = getSelectedLocation();
	if (address_selected) {
		selected_filters.push({
			key: 'selected_location',
			option: {
				id: 'selected_location',
				name: address_selected,
			},
		});
	}

	return selected_filters;
}

export type CareersPageLocationRadiusSearchFilter = {
	unit: 'mile' | 'km',
	latitude: string,
	longitude: string,
	radius: number,
};

export function getLocationFilters(): CareersPageLocationRadiusSearchFilter {
	return RB.init_data.radius_search_parameters;
}

export function isFilterAvailable() {
	const all_filters = getAllFiltersAvailable();
	return Object.entries(all_filters).filter(([filter_key, filter_data]) => filter_data.options.length > 0).length
		? true
		: false;
}

export function getAddressFromCoordinates({ latitude, longitude }) {
	return Geocode.fromLatLng(latitude, longitude);
}

export function getQueryString(field) {
	const href = window.location.href;
	const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
	const string = reg.exec(href);
	return string ? string[1] : null;
}

export function decodeAddress(address) {
	if (address) {
		return decodeURIComponent(address.replace(/\+/g, ' '));
	}
	return '';
}

export function getSelectedLocation() {
	return decodeAddress(getQueryString('loc'));
}

export function getAvailableJobsAvailable() {
	return RB.init_data.jobs_for_selection;
}

export function getOrderByValue() {
	return getQueryString('sort_by');
}

export function getPaginatorObject() {
	return RB.init_data.paginator;
}

export function getSelectedLimit() {
	return getQueryString('limit') ? parseInt(getQueryString('limit')) : 25;
}
